import { render, staticRenderFns } from "./ProductJournalSalesCheck.vue?vue&type=template&id=71bd0836&"
import script from "./ProductJournalSalesCheck.vue?vue&type=script&lang=js&"
export * from "./ProductJournalSalesCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports